import { render, staticRenderFns } from "./TahsilatlarChart.vue?vue&type=template&id=bbb6bcc2"
import script from "./TahsilatlarChart.vue?vue&type=script&lang=ts"
export * from "./TahsilatlarChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports